import cn from "classnames";
import { formFieldTrns } from "src/components/FormField/trns";
import { ISelectOption } from "src/@types/form";
import { TextField } from "src/components/FormField/TextField";
import {
  COMPANY_NAME_ADDRESS_SITE_FIELDS,
  DESCRIPTION_FIELD,
  getCountryField,
  getIndustryField,
  getReprecentionCountriesField,
  INTERNATIONAL_FIELD,
  NAMES_FIELDS,
} from "src/page-components/auth/RegistrationForm/constants/fields";
import { RegistrationFields } from "src/page-components/auth/RegistrationForm/types";
import { settignsSubtitlesTrns, settignsTrns } from "../trns";
import { ISettingsItem } from "../types";

const DEFAULT_FIELDS_CONTAINER_CLASSNAMES =
  "flex justify-center items-center w-full";

export const getSettingItemsForOwner = (
  industriesOptions: ISelectOption[],
  countriesOptions: ISelectOption[],
  countriesWithInternerOptions: ISelectOption[]
): ISettingsItem[] => {
  return [
    {
      id: "1",
      title: { i18nKey: settignsTrns.countryOfRegistration },
      fields: getCountryField(countriesOptions),
    },
    {
      id: "2",
      title: { i18nKey: settignsTrns.companyInfo },
      fieldsContainerClassName: cn(
        DEFAULT_FIELDS_CONTAINER_CLASSNAMES,
        "flex-col gap-5 sm:gap-3 sm:flex-row"
      ),
      fields: COMPANY_NAME_ADDRESS_SITE_FIELDS,
    },
    {
      id: "3",
      title: { i18nKey: settignsTrns.responsiblePerson },
      fieldsContainerClassName: cn(
        DEFAULT_FIELDS_CONTAINER_CLASSNAMES,
        "flex-col gap-5 sm:gap-3 sm:flex-row"
      ),
      fields: NAMES_FIELDS,
    },
    {
      id: "4",
      title: { i18nKey: settignsTrns.briefInfo },
      fields: DESCRIPTION_FIELD,
    },
    {
      id: "5",
      title: { i18nKey: settignsTrns.chooseIndustry },
      fields: getIndustryField(industriesOptions),
    },
    {
      id: "6",
      title: { i18nKey: settignsTrns.internationalMarket },
      description: { i18nKey: settignsSubtitlesTrns.internationalMarket },
      fields: INTERNATIONAL_FIELD,
    },
    {
      id: "7",
      title: { i18nKey: settignsTrns.countriesOfRepresentation },
      fields: getReprecentionCountriesField(countriesWithInternerOptions),
    },
    {
      id: "8",
      title: { i18nKey: settignsTrns.loggingInData },
      fieldsContainerClassName: cn(
        DEFAULT_FIELDS_CONTAINER_CLASSNAMES,
        "flex-col gap-5 sm:gap-3 sm:flex-row"
      ),
      fields: [
        {
          component: TextField,
          type: "tel",
          name: RegistrationFields.phoneNumber,
          label: { i18nKey: formFieldTrns.phoneNumber },
          errorClassName: "absolute -bottom-6",
        },
        {
          component: TextField,
          name: RegistrationFields.password,
          label: { i18nKey: formFieldTrns.newPassword },
          type: "password",
          errorClassName: "absolute -bottom-6",
        },
      ],
    },
  ];
};

export const getSettingItemsForAgent = (
  countriesOptions: ISelectOption[]
): ISettingsItem[] => {
  return [
    {
      id: "1",
      title: { i18nKey: settignsTrns.countryOfRegistration },
      fields: getCountryField(countriesOptions),
    },
    {
      id: "2",
      title: { i18nKey: settignsTrns.companyInfo },
      fieldsContainerClassName: cn(
        DEFAULT_FIELDS_CONTAINER_CLASSNAMES,
        "flex-col gap-5 sm:gap-3 sm:flex-row"
      ),
      fields: COMPANY_NAME_ADDRESS_SITE_FIELDS,
    },
    {
      id: "3",
      title: { i18nKey: settignsTrns.responsiblePerson },
      fieldsContainerClassName: cn(
        DEFAULT_FIELDS_CONTAINER_CLASSNAMES,
        "flex-col gap-5 sm:gap-3 sm:flex-row"
      ),
      fields: NAMES_FIELDS,
    },
    {
      id: "4",
      title: { i18nKey: settignsTrns.briefInfo },
      fields: DESCRIPTION_FIELD,
    },
    {
      id: "5",
      title: { i18nKey: settignsTrns.loggingInData },
      fieldsContainerClassName: cn(
        DEFAULT_FIELDS_CONTAINER_CLASSNAMES,
        "flex-col gap-5 sm:gap-3 sm:flex-row"
      ),
      fields: [
        {
          component: TextField,
          type: "tel",
          name: RegistrationFields.phoneNumber,
          label: { i18nKey: formFieldTrns.phoneNumber },
          errorClassName: "absolute -bottom-5 lg:-bottom-6",
        },
        {
          component: TextField,
          name: RegistrationFields.password,
          label: { i18nKey: formFieldTrns.newPassword },
          type: "password",
          errorClassName: "absolute -bottom-5 lg:-bottom-6",
        },
      ],
    },
  ];
};
